import { ComponentMetadata } from '@/common/components/types';

export type ListingType = 'slider' | 'grid' | 'masonry';

export const ACRONYMS = {
  ARTIST: 'ar',
  BRAND: 'br',
  BRAND_OF_THE_WEEK: 'botw',
  BESTSELLING: 'bs',
  CATEGORY_LISTING: 'cat',
  COLECTION_VIEW: 'col',
  FREQUENTLY_BOUGHT_TOGETHER: 'fbt',
  KEYWORDS: 'kw',
  MORE_FROM_THIS_COLLECTION: 'mftc',
  MORE_LIKE_THIS: 'mlt',
  OTHER_USERS_ALSO_VIEWED: 'ouav',
  PROMO_PAGE: 'pp',
  RECENTLY_VIEWED: 'rv',
  STANDARD_VIEW: 'st',
  TRENDING_POSTERS: 'tp',
  YOU_MIGHT_ALSO_LIKE: 'ymal',
  THIS_MIGHT_INTEREST_YOU: 'tmiy',
  DISCOVER_EXCLUSIVE_POSTERS_FROM_TOP_BRANDS: 'depftb',
  // TEMPORARY
  PRODUCT_ADDED_TO_CART: 'patc',
  UNKNOWN: 'unknown', // <- placeholder for values not provided by analytic team
} as const;

export const LISTING_FUNCTIONS = {
  POPULAR: 'popular',
  SIMILAR: 'similar',
  BESTSELLING: 'bestselling',
  INSPIRATIONAL: 'inspirational',
  FOLLOW: 'followed_authors',
  TRENDING: 'trending',
  PERSONALIZED: 'personalized',
};

type AcronymKeys = keyof typeof ACRONYMS;
export type AcronymType = (typeof ACRONYMS)[AcronymKeys];

type ListingFunctionsKeys = keyof typeof LISTING_FUNCTIONS;
export type ListingFunctionType = (typeof LISTING_FUNCTIONS)[ListingFunctionsKeys];

export interface EventItem {
  index: number;
  item_id: string;
  item_variant: string;
  item_list_id: string;
  item_list_name: string;
  optimized_feed_id?: string;
  search_category?: string;
  listing_sort_method?: string;
}

interface Message {
  index: number;
  externalId: number;
  internalId: number;
  name?: string;
}
export interface EventMessage {
  metadata: ComponentMetadata;
  message: Message;
}
